import { useCallback } from 'react';

import { useDataProvider } from '@work4all/data';

import { MailboxConfiguration } from '@work4all/models/lib/Classes/MailboxConfiguration.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { MailboxFeatures } from '@work4all/models/lib/Enums/MailboxFeatures.enum';

const REQUEST: DataRequest = {
  entity: Entities.mailboxConfiguration,
  data: {
    id: null,
    smtpAddress: null,
    features: null,
  },
  completeDataResponse: true,
};

export const useMailboxFeatures = () => {
  const { data } = useDataProvider<MailboxConfiguration>(REQUEST);

  const hasFeature = useCallback(
    (id: string, feature: MailboxFeatures) => {
      const configuration = data?.find((configuration) => {
        return configuration.id === id;
      });

      const features = configuration?.features ?? [];

      return features.includes(feature);
    },
    [data]
  );

  return { hasFeature };
};
